import { Component, Input } from '@angular/core';
import { MatChipInputEvent } from '@angular/material';
import { ENTER } from '@angular/cdk/keycodes';

@Component({
  selector: 'qas-chips',
  templateUrl: './chips.component.html',
  styleUrls: [ './chips.component.scss' ]
})
export class ChipsComponent {
  @Input() chips!: string[];
  readonly separatorKeysCodes = [ ENTER ];

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    let trimmedValue = (value || '').trim();
    if (trimmedValue && this.chips.indexOf(trimmedValue) < 0) {
      this.chips.push(trimmedValue);
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(value: string): void {
    const index = this.chips.indexOf(value);

    if (index >= 0) {
      this.chips.splice(index, 1);
    }
  }
}
